/**
 * Деньги в базе хранятся в копейках (RUB, 2 знака). Здесь — единственное
 * место, где они превращаются в текст для людей: «2 490 ₽», а копейки
 * показываем только когда они ненулевые («2 490,50 ₽»).
 */
export const formatRub = (minor: number | null | undefined): string => {
  const value = (Number(minor) || 0) / 100
  const hasKopecks = Math.round(value * 100) % 100 !== 0
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: hasKopecks ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(value)
}
